__turbopack_context__.v({
  "actions": "SplitFeature-module__pXfRbW__actions",
  "body": "SplitFeature-module__pXfRbW__body",
  "chevron": "SplitFeature-module__pXfRbW__chevron",
  "grid": "SplitFeature-module__pXfRbW__grid",
  "icon": "SplitFeature-module__pXfRbW__icon",
  "item": "SplitFeature-module__pXfRbW__item",
  "label": "SplitFeature-module__pXfRbW__label",
  "list": "SplitFeature-module__pXfRbW__list",
  "media": "SplitFeature-module__pXfRbW__media",
  "panel": "SplitFeature-module__pXfRbW__panel",
  "panelInner": "SplitFeature-module__pXfRbW__panelInner",
  "panelText": "SplitFeature-module__pXfRbW__panelText",
  "row": "SplitFeature-module__pXfRbW__row",
  "title": "SplitFeature-module__pXfRbW__title",
  "trigger": "SplitFeature-module__pXfRbW__trigger",
});
